import z from 'zod'

const zEnv = z.object({
  MODE: z.enum(['development', 'preview', 'production']),
  VITE_GIT_HASH: z.string(),
  VITE_BACKEND_URL: z.string(),
  // External REST API + MCP server (services/api). Defaults to the local dev
  // port when omitted so `just dev` works without extra env wiring.
  VITE_API_URL: z.string(),
  VITE_STRIPE_PORTAL_URL: z.string(),
  VITE_LINKEDIN_CLIENT_ID: z.string(),
  VITE_INSTAGRAM_CLIENT_ID: z.string(),
  VITE_TIKTOK_CLIENT_ID: z.string(),
  // Facebook is opt-in: leaving these unset works for dev environments that
  // don't have Meta credentials. The auth flow will throw clearly if invoked.
  // The Configuration ID identifies a Facebook Login for Business
  // Configuration in the Meta App Dashboard, which defines the permissions
  // requested by the OAuth dialog (we no longer pass `scope` directly).
  VITE_FACEBOOK_CLIENT_ID: z.string().default(''),
  VITE_FACEBOOK_CONFIG_ID: z.string().default(''),
  VITE_GOOGLE_CLIENT_ID: z.string(),
  VITE_GOOGLE_SERVICES_API_KEY: z.string(),
})

const getEnvEntries = () => {
  return Object.entries(import.meta.env).reduce(
    (acc, [key, value]) => {
      acc[key] = value
      return acc
    },
    {} as { [key: string]: unknown },
  )
}

const env = zEnv.strip().parse(getEnvEntries())

export default env
